import { render } from "./DzenSources.vue?vue&type=template&id=79d4dbb6&scoped=true"
import script from "./DzenSources.vue?vue&type=script&lang=js"
export * from "./DzenSources.vue?vue&type=script&lang=js"

import "./DzenSources.vue?vue&type=style&index=0&id=79d4dbb6&scoped=true&lang=css"
import "./DzenSources.vue?vue&type=style&index=1&id=79d4dbb6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d4dbb6"]])

export default __exports__